import { FC, ReactNode } from 'react';
import { Typography } from '@altermaind/web/ui';

/**
 * Inline wrapper used by `EmbeddedStyle` to render text between `<b>` / `</b>`
 * (and `<strong>` / `</strong>`) placeholders in bold. Renders as an inline
 * `Typography` so it can be safely nested inside another Typography without
 * breaking the line flow.
 *
 * @param {ReactNode} children - Content to be rendered in bold.
 *
 * @returns {JSX.Element} The bolded inline content.
 */
export const BoldLabel: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Typography as='span' fontWeight='bold'>
      {children}
    </Typography>
  );
};
